import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@mui/material';
/**
 * Rounded avatar showing the user's picture, falling back to bold initials on
 * the tinted surface. Size and corner radius come from the caller's `sx`.
 */
export const UserAvatar = ({ user, sx }) => (_jsx(Avatar, { src: user.avatarUrl, alt: user.loginName, variant: 'rounded', sx: [{ bgcolor: 'surface3', color: 'text.secondary', fontWeight: 700 }, ...(Array.isArray(sx) ? sx : [sx])], children: user.loginName.slice(0, 2).toUpperCase() }));
//# sourceMappingURL=user-avatar.js.map